import type { Chapter, NovelMetadata, NovelData } from "../data-model/novel.js";
import { NovelDataSchema } from "../data-model/schema.js";

export function assembleNovelData(
  metadata: NovelMetadata,
  results: readonly Chapter[],
): NovelData {
  // Sort by original ChapterRef.index. Do NOT renumber: a partial result
  // (some chapters permanently failed) must preserve gaps so the index in
  // each Chapter still matches its source position.
  const sorted = [...results].sort((a, b) => a.index - b.index);
  // Never backfill totalChapters from sorted.length: in bounded chapterRange
  // mode the slice can be far smaller than the source TOC.
  return NovelDataSchema.parse({ metadata, chapters: sorted });
}
